export const HISTORICAL_FCI_REPORT_ID = "all-through-2026-09";
export const HISTORICAL_FCI_REPORT_START = "2026-01-01";
export const HISTORICAL_FCI_REPORT_CUTOFF = "2026-09-30";

export const fciReportFilters = (selection) => (
  selection === HISTORICAL_FCI_REPORT_ID
    ? {
      _paymentDateFrom: HISTORICAL_FCI_REPORT_START,
      _paymentDateTo: HISTORICAL_FCI_REPORT_CUTOFF,
    }
    : { _period: selection }
);
